<template>
  <div class="hero-section">
    <div class="main-container">

      <div class="info-container">
        <h1 class="text-highlight-reverse">We transform your</h1>
        <hero-title-animation
          label="vivid imagination"
        />
        <h1 class="text-highlight-reverse">into software solution</h1>
        <h6 class="hero-content">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum
          has been the
          industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into
          electronic typesetting, remaining essentially unchanged.</h6>

        <div class="button-container">
          <vi-button
            button-label="get in touch"
          />
          <vi-button
            button-label="our products"
            :is-clear="true"
          />
        </div>

      </div>

      <div class="img-container">
        <img src="../assets/background-decoration/prop-hero-section.jpg" alt="">
      </div>
    </div>

  </div>
</template>

<script>
import ViButton from "../components/ViButton";
import HeroTitleAnimation from "../components/HeroTitleAnimation";

export default {
  name: 'HeroSection',
  components: {HeroTitleAnimation, ViButton},
}
</script>

<style lang="scss">
@import "HeroSection.scss";
</style>
